import { ReactNode } from 'react'

type Props = { text: ReactNode }
const TalkingHippo = ({ text }: Props) => {
    return (
        <div className="flex flex-1 justify-end overflow-x-clip">
            <div className="flex flex-1 animate-hippo-in flex-col justify-end">
                <div className="chat chat-start flex h-[70px] items-center">
                    <div className="avatar chat-image">
                        <div className="w-20">
                            <img alt="" src="/hippos/sitting.svg" />
                        </div>
                    </div>
                    <div className="chat-bubble chat-bubble-primary max-w-[280px] -translate-y-[50%] animate-fade-in text-sm animation-delay-700 md:text-base">
                        {text}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default TalkingHippo
